import React, { useEffect, useRef } from 'react';
import { LocaleRestrictionPage as LocaleRestrictionPageWebApp } from 'Roblox';

function LocaleRestrictionPageLoader(): JSX.Element {
  const entryPointRef = useRef<HTMLDivElement | null>(null);

  // Render LocaleRestrictionPage webapp on mount.
  useEffect(() => {
    if (!entryPointRef.current) {
      throw new Error('Failed to find entry point element for LocaleRestrictionPageLoader.');
    }
    LocaleRestrictionPageWebApp.renderComponent(entryPointRef.current);
  }, []);

  return <div ref={entryPointRef} />;
}

export default LocaleRestrictionPageLoader;
